<template>
    <div class="customer-detail-sales-y-container default-table" v-loading="loading" element-loading-text="拼命加载中">
        <div class="tip">
            <template v-if="mainCustomerYF===MapType.Y">
                当前客户为年框客户，可对不同销售管理该客户是否是年框客户
            </template>
            <template v-else>当前客户为非年框客户，故对应销售都是非年框客户</template>
        </div>
        <el-table :data="tableData" style="width: 100%" height="calc(100% - 58px)">
            <el-table-column prop="sale" label="销售" align="center"/>
            <el-table-column prop="sign_end" label="是否年框" align="center">
                <template v-slot="{row:{year_frame}}">
                    <span v-if="year_frame=== 'Y'" style="color: #ff3176"><i class="el-icon-star-on"/>年框</span>
                    <template v-else><i class="el-icon-star-off"/>非年框</template>
                </template>
            </el-table-column>
            <el-table-column v-if="mainCustomerYF===MapType.Y&&userAuth.can_customer_sale_year_frame" label="操作"
                             align="center">
                <template v-slot="{row:{id,year_frame}}">
                    <el-popconfirm
                            :title="`确认${year_frame === 'N' ? '设置' : '取消'}年框吗？`"
                            @confirm="confirmModify(id,year_frame)">
                        <el-button slot="reference" size="mini" round>
                            {{ year_frame === 'N' ? '设置' : '取消' }}年框
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import {theCustomerSalesYF, theCustomerSalesModifyYF} from '@/api/customers';

const MapType = {
    Y: 'Y',
    N: 'N',
}
export default {
    name: "detailSaleYearFrame",
    props: {
        customerId: {
            type: [String, Number],
            required: true
        },
    },
    data() {
        return {
            MapType,
            loading: false,
            tableData: [],
            mainCustomerYF: MapType.N, // 客户是不是年框客户
        }
    },
    computed: {
        userAuth() {
            return this.$store.getters.getUserAuth;
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            this.loading = true
            const {model} = await theCustomerSalesYF({customer_id: this.customerId})
            this.loading = false
            this.tableData = model.data || []
            this.mainCustomerYF = model.customer_year_frame || MapType.N
        },
        async confirmModify(id, year_frame) {
            year_frame = year_frame === MapType.Y ? MapType.N : MapType.Y;
            const response = await theCustomerSalesModifyYF({id, year_frame})
            if (!response.success) {
                this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
                return;
            }
            this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
            await this.init()
        }
    }
}
</script>
<style lang="scss">
.customer-detail-sales-y-container {
  padding: 12px 12px 12px 24px;
  border-radius: 6px;
  border: 1px dashed rgb(221, 221, 221);
  height: calc(100% - 40px);

  .el-button--mini.is-round {
    padding: 2px 15px;
  }

  .tip {
    display: flex;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 8px 18px;
    width: 100%;
    height: 32px;
    border-radius: 9px;
    background-image: -webkit-gradient(linear, right top, left top, from(rgba(255, 0, 0, .06)), to(rgba(61, 127, 255, .09)));
    background-image: linear-gradient(270deg, rgba(255, 0, 0, .06), rgba(61, 127, 255, .09));
  }
}
</style>
